module.exports = __webpack_public_path__ + "static/img/identity_demo.62e5bea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/identity_demo.png
// module id = 4Yqh
// module chunks = 1